import * as u from './utils.js'

/*---------------------------------------------*/

export default class AppContextMgr {
	static DEFS = {
		templates: {
			simple: {
				minWidth: 220
			},
			simple_bubble: {
				minWidth: 280
			},
			default: {
				minWidth: 220
			},
			default_bubble: {
				minWidth: 280
			},
			side_image: {
				minWidth: 276
			},
			side_image_bubble: {
				minWidth: 298
			},
			quote: {
				minWidth: 220
			},
			card: {
				minWidth: 400
			}
		}
	}

	constructor() {
		this.initialized = false;
		this.desktopSettings = null;
		this.mobileSettings = null;
		this.DEFS = AppContextMgr.DEFS;

		var is_mobile_agent = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		var is_mobile_wix = window.Wix && window.Wix.Utils && window.Wix.Utils.getDeviceType && (window.Wix.Utils.getDeviceType() === 'mobile');
		var is_mobile_override = u.getLocal('mobile'); 
		this.device = (is_mobile_agent || is_mobile_wix || is_mobile_override) ? 'mobile' : 'desktop';

		if (typeof window.Wix != 'undefined' && window.Wix.Styles) {
			window.Wix.Styles.getStyleParams();
		}
		// this.device = 'mobile';
	}

	update = (desktopSettings,mobileSettings) => {
		this.initialized = true;
		this.desktopSettings = desktopSettings || {};
		this.mobileSettings = mobileSettings || {};
	}

	get = (path,defaultDesktopValue,defaultMobileValue) => {
		if (this.isMobile()) {
			let value = window.U.getSafe(this.mobileSettings, path, defaultMobileValue);
			if (typeof value !== 'undefined')
				return value;
		}

		return window.U.getSafe(this.desktopSettings,path,defaultDesktopValue);
	}

	default = (path) => {
		if (this.isMobile()) {
			let value = window.U.getSafe(window.DEFAULT_APP_SETTINGS.mobile, path);
			if (typeof value !== 'undefined')
				return value;
		}

		return window.U.getSafe(window.DEFAULT_APP_SETTINGS.desktop,path);
	}

	set = (path,value) => {
		if (this.device === 'mobile')
			return window.U.setSafe(this.mobileSettings, path, value);
			
		return window.U.setSafe(this.desktopSettings,path,value);
	}

	isInitialized = () => this.initialized;

	device = () => this.device;
	isMobile = () => (this.device === 'mobile');
	isDesktop = () => (this.device === 'desktop');
}
